import React from 'react';
import ReactDOM from 'react-dom/client';
import MainRouter from "./routes/MainRouter";
import TawkChat from "./components/atoms/TawkChat/TawkChat";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
// Métodos de objetos
import 'core-js/features/object/entries'; // Object.entries
import 'core-js/features/object/values'; // Object.values

// Métodos de arrays
import 'core-js/features/array/includes'; // Array.prototype.includes

// Métodos de cadenas
import 'core-js/features/string/includes'; // String.prototype.includes
import 'core-js/features/string/starts-with'; // String.prototype.startsWith
import 'core-js/features/string/ends-with'; // String.prototype.endsWith

// Métodos de números
import 'core-js/features/number/is-nan'; // Number.isNaN

// Soporte para conjuntos y mapas (opcional)
import 'core-js/features/map';
import 'core-js/features/set';
import 'regenerator-runtime/runtime';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <MainRouter/>
      <TawkChat/>
  </React.StrictMode>
);
